// extracted by mini-css-extract-plugin
module.exports = {"progressWrap":"backToTopButton_progressWrap__bg1YT","activeProgress":"backToTopButton_activeProgress__nl_ei"};